import { Common, color } from '@stockbit/ui';

import Image from 'global/Image';
import { FALLBACK_AVATAR_SRC } from 'global/TradingModal/RealTradingModal/ModalBonds/constants';
import Link from 'next/link';
import { ChevronRightSvg } from 'features/day-trade/components/Icons';
import { useBondPortfolioStore } from 'global/TradingModal/RealTradingModal/ModalBonds/stores/useBondPortfolioStore';

import { formatPercentage } from 'utils/number';
import If from 'global/ErrorHandlers/If';
import { CompanyCard } from './styled';

const { Text, Flex } = Common;

interface BondsCompanyType {
  showPrice: boolean;
  symbol: string;
  iconUrl: string;
  bondsName: string;
  showBondPrice?: boolean;
}

const BondsCompany = ({
  showPrice,
  symbol,
  iconUrl,
  bondsName,
  showBondPrice = false,
}: BondsCompanyType) => {
  const [product] = useBondPortfolioStore((s) => [s.product]);

  return (
    <CompanyCard>
      <Link href={`/symbol/${symbol}`}>
        <Flex as="a" justify="space-between" align="center" width="100%">
          <Flex
            align="center"
            width={showPrice ? '320px' : '100%'}
            data-cy="trade-detail-modal-bond-company-show-price"
          >
            <Image
              src={iconUrl || FALLBACK_AVATAR_SRC}
              style={{ width: '40px', height: '40px', background: 'white' }}
              data-cy="trade-detail-modal-company-image"
            />
            <Flex direction="column" pl="15px">
              <Flex align="center">
                <Text family="bold">{symbol}</Text>
              </Flex>
              <Text
                size="12px"
                color={color.midgray}
                mr="5px"
                mt="3px"
                ellipsis
              >
                {bondsName}
              </Text>
            </Flex>
          </Flex>

          <If condition={showBondPrice}>
            <Flex direction="column" pr="8px">
              <Text family="bold" align="right" width="80px">
                {formatPercentage(
                  product?.meta?.sell_price_rate,
                  false,
                  '0,0.00',
                  true,
                )}
              </Text>
              <Text color="#969696" size="14px" align="right" width="80px">
                Harga Jual
              </Text>
            </Flex>
          </If>
          <ChevronRightSvg />
        </Flex>
      </Link>
    </CompanyCard>
  );
};

export default BondsCompany;
